import React from 'react';

export default function NoAccess() {
  return (
    <>
      <h1>You do not have required authorization for this page.</h1>
    </>
  );
}
